<template>
    <div class="group">
        <strong>Minimum Project Cost</strong>
        <div>
            <costFormatter v-model="minValue" placeholder="Set min cost"/>
        </div>
        <strong>Maximum Project Cost</strong>
        <div>
            <costFormatter v-model="maxValue" placeholder="Set max cost"/>
        </div>
    </div>
</template>

<script>
    import costFormatter from "./costFormatter";
    export default {
        name: "costFilter",
        components: {costFormatter},
        data: function () {
            return {
                minValue: 0,
                maxValue: 0,
            }
        },
        watch: {
            minValue: function () {
                this.$emit("input", ['project_cost', this.minValue, this.maxValue])
            },
            maxValue: function () {
                this.$emit("input", ['project_cost', this.minValue, this.maxValue])
            }
        }
    }
</script>

<style scoped>
    .group {
        padding: 4px 2px;
        color: #FFFFFF;
        background: #64983d;
        font-size: 1.25rem;
        margin-bottom: 1px;
        line-height: 1;
    }
</style>